import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Spacing, FontWeight, Media } from '../../theme';
import { styleWhenTrue, hexToRgba } from '../../utils';

import { MenuPositionItemData } from './header.types';
import LocalMenuIconFile from './images/menu.inline.svg';

export const Container = styled.div`
  width: calc(100% - 2 * ${Spacing.DesktopWide});
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 23px ${Spacing.DesktopWide};
  box-shadow: 0 2px 5px 0 ${hexToRgba(Color.silver, 0.15)};
  ${Media.desktop`
    padding: 23px ${Spacing.Desktop};
    width: calc(100% - 2 * ${Spacing.Desktop});
  `}
  ${Media.tablet`
    padding: 23px ${Spacing.Tablet};
    width: calc(100% - 2 * ${Spacing.Tablet});
    box-shadow: 0 2px 5px 0 ${hexToRgba(Color.silver, 0.15)};
  `}
`;

export const MenuIconFile = styled(LocalMenuIconFile)`
  width: 28px;
  g {
    fill: ${Color.primary};
  }
`;

export const CompanyLogoContainer = styled.div`
  margin-left: 70px;
  ${Media.desktopWide`
    margin-left: 25px;
  `}
  ${Media.tablet`
    margin-left: 30px;
  `}
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  ${Media.tablet`
    max-width: calc(100% - 74px);
  `}
  a {
    text-decoration: none;
  }
`;

export const MenuPositionItem = styled.div<MenuPositionItemData>`
  color: ${Color.grey};
  font-size: 16px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 20px;
  flex-shrink: 0;
  & + & {
    margin-left: 35px;
    ${Media.desktop`
      margin-left: 20px;
    `}
  }
  a {
    text-decoration: none;
    color: ${Color.grey};
    outline: 0;
    ${styleWhenTrue(prop('isActive'), css`
      color: ${Color.primary};
    `)}
  }
`;

export const MenuPositionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 40px;
  ${Media.desktop`
    display: none;
  `}
`;
